import { updateFiltersFront, setKeyFilterSelected } from "../../../redux/actions/userActions";
import connect from "react-redux/es/connect/connect";
import Filter from "../../../components/filter/Filter";

const mapStateToProps = (state, ownProps) => {
  return {
    filters: state.user.filters ? state.user.filters[ownProps.filterTargetKey] : [],
    currentFilters: state.user.currentFilters ? state.user.currentFilters[ownProps.filterTargetKey] : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder,
    maxItemsToDisplay: 1000
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updateFiltersFront(ownProps.filterTargetKey, values));
    },

    setKeyFilterSelected: () => {
      dispatch(setKeyFilterSelected(ownProps.filterTargetKey));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);



// WEBPACK FOOTER //
// src/containers/admin/users/FilterContainer.js